<template>
  <a class="whats-app" href="https://wa.link/iak2wt" target="_blank">
    <i class="ri-whatsapp-fill animation-icon"></i>
  </a>
</template>

<script>
export default {
  name: 'WhatsAppButton'
}
</script>

<style scoped>
.whats-app {
  position: fixed;
  width: 50px;
  height: 50px;
  bottom: 75px;
  background: #25D366;
  color: #FFF;
  border-radius: 50%;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 3px 4px 3px #999;
  right: 15px;
  z-index: 100;
  transition: all 0.3s ease;
  text-decoration: none;
}

.whats-app:hover {
  background: #128C7E;
  transform: scale(1.1);
  box-shadow: 4px 6px 6px #666;
}

.animation-icon {
  font-size: 30px;
  animation: rotation-animation 2s infinite;
}

@keyframes rotation-animation {
  0% {
    transform: rotate(0deg);
  }
  50% {
    transform: rotate(30deg);
  }
  100% {
    transform: rotate(0deg);
  }
}
</style>
